<template>
	<v-tabs 
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Configurazione" ripple class="secondary-tab">
			Configurazione
		</v-tab>
        <v-tab key="Altro" ripple class="secondary-tab">
			Altro
		</v-tab>

		<v-tab-item class="pb-offset background-1 pt-3" key="Configurazione">
			<v-row class="ma-0 pb-offset">
                <v-col cols="12" class="pa-0">
                    <v-stepper v-model="stepIndex" vertical non-linear class="elevation-0 w100p">
                        <v-stepper-step :complete="stepIndex > 1" step="1">
                            <span class="body-2">Configura i tuoi dati Fiscali</span>
                        </v-stepper-step>

                        <v-stepper-content step="1">
                            <v-card class="background-2 round-card mb-5">
                                <v-subheader>Inserisci i dati della tua azienda per la fatturazione elettronica </v-subheader>

                                <v-row class="ma-0">
                                    <v-col cols="12" lg="4" class="col-12 col-sm-6 col-md-6 col-lg-4 px-4 pb-0">
                                        <v-text-field
                                            label="P.IVA"
                                            v-model="settings_einvoice['vat_number']"
                                            required
                                            :error-messages="errors.collect('P.IVA')"
                                            v-validate="'required'"
                                            data-vv-name="P.IVA"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="ma-0">
                                    <v-col cols="12" lg="4" class="col-12 col-sm-6 col-md-6 col-lg-4 px-4 pb-0">
                                        <v-text-field
                                            label="Ragione Sociale"
                                            v-model="settings_einvoice['business_name']"
                                            required
                                            :error-messages="errors.collect('Ragione Sociale')"
                                            v-validate="'required'"
                                            data-vv-name="Ragione Sociale"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="ma-0">
                                    <v-col cols="12" lg="4" class="col-12 col-sm-6 col-md-6 col-lg-4 px-4 pb-0">
                                        <v-text-field
                                            label="Email"
                                            v-model="settings_einvoice['business_email']"
                                            required
                                            :error-messages="errors.collect('Email')"
                                            v-validate="'required'"
                                            data-vv-name="Email"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-btn class="my-4" color="primary" @click="validateStepForm()">Continua</v-btn>
                        </v-stepper-content>

                        <v-stepper-step :complete="stepIndex > 2" step="2">
                            <span class="body-2">Seleziona quale applicazione integrare con GiveMeHive</span>
                        </v-stepper-step>
                        <v-stepper-content step="2">
                            <v-card class="background-2 round-card mb-5">
                                <v-row class="ma-0 pb-3">
                                    <v-col cols="12">	
                                        <v-radio-group v-model="settings_einvoice['einvoice_provider']" class="pl-4 pt-3" :mandatory="false">
                                            <v-radio color="primary" label="OpenApi" value="open_api"></v-radio>
                                            <v-radio color="primary" label="Aruba" value="aruba"></v-radio>
                                            <v-radio color="primary" label="OS1" value="os1"></v-radio>
                                            <v-radio color="primary" label="Nessuno" value="nothing"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <!-- <v-col class="col-12 px-4 pb-0" v-if="['aruba'].includes(settings_einvoice['einvoice_provider'])">
                                        <v-text-field
                                            label="Username"
                                            v-model="settings_einvoice['username']"
                                            required
                                            :error-messages="errors.collect('Username')"
                                            v-validate="'required'"
                                            data-vv-name="Username"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="col-12 px-4 pb-0" v-if="['aruba'].includes(settings_einvoice['einvoice_provider'])">
                                        <v-text-field
                                            label="Password"
                                            v-model="settings_einvoice['password']"
                                            required
                                            :error-messages="errors.collect('Password')"
                                            v-validate="'required'"
                                            data-vv-name="Password"
                                            outlined
                                            dense
                                            :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="() => {e1 = !e1}"
                                            :type="!e1 ? 'password' : 'text'"
                                        ></v-text-field>
                                    </v-col> -->
                                    <v-col class="col-12 px-4 pb-0" v-show="['open_api', 'aruba'].includes(settings_einvoice['einvoice_provider'])">
                                        <v-switch
                                            inset
                                            v-model="settings_einvoice['einvoice_sandbox']"
                                            label="Attiva modalità SandBox"
                                        ></v-switch>
                                    </v-col>
                                    <!-- <v-col class="col-12 px-4 pb-0" v-show="settings_einvoice['einvoice_provider'] == 'open_api'">
                                        <v-switch
                                            inset
                                            v-model="settings_einvoice['apply_legal_storage']"
                                            label="Abilitare la funzionalità di archiviazione legale"
                                        ></v-switch>
                                    </v-col>
                                    <v-col class="col-12 px-4 pb-0" v-show="settings_einvoice['einvoice_provider'] == 'open_api'">
                                        <v-switch
                                            inset
                                            v-model="settings_einvoice['apply_signature']"
                                            label="Abilita le firme digitali"
                                        ></v-switch>
                                    </v-col> -->
                                    <v-col class="col-12 px-4 pb-0" v-show="['open_api'].includes(settings_einvoice['einvoice_provider'])">
                                        <v-switch v-if="settings_einvoice.id"
                                            inset
                                            v-model="settings_einvoice['active']"
                                            label="Attiva"
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                                    
                                <v-divider></v-divider>
                                <v-row class="ma-0 py-2">
                                    <v-col cols="12" class="text-right pr-3" v-show="['open_api', 'aruba'].includes(settings_einvoice['einvoice_provider'])">
                                        <v-spacer></v-spacer>
                                        <v-btn class="mr-4" color="info" @click="saveConfigurations()" :loading="registering" :disabled="!!settings_einvoice.id">Registra Configurazione</v-btn>
                                        <v-btn class="mr-4" color="info" @click="updateConfigurations()" :loading="registering" v-if="!!settings_einvoice.id">Aggiorna Configurazione</v-btn>
                                        <v-btn class="mr-4" color="info" @click="deleteConfigurations()" :loading="deleting" v-if="!!settings_einvoice.id">Elimina Configurazione</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-btn class="my-4" @click="stepIndex--" text>Indietro</v-btn>

                        </v-stepper-content>
                        
                    </v-stepper>
                </v-col>
			</v-row>
		</v-tab-item>
        
        <v-tab-item class="pb-offset background-1 pt-3" key="Altro">
			<v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                    <v-card class="background-2 round-card mb-5">
                        <v-subheader class="body-2">Altre configurazioni</v-subheader>
                        <v-row class="ma-0">
                            <v-col class="col-12 px-4 pb-0" v-show="['open_api', 'aruba'].includes(settings_einvoice['einvoice_provider'])">
                                <v-switch
                                    inset
                                    v-model="settings['attach_courtesy_invoice']"
                                    label="Allega in XML Fattura di Cortesia"
                                ></v-switch>
                            </v-col>
                        </v-row>

                            
                        <v-divider></v-divider>
                        <v-row class="ma-0 py-2">
                            <v-col cols="12" class="text-right pr-3" v-show="['open_api', 'aruba'].includes(settings_einvoice['einvoice_provider'])">
                                <v-spacer></v-spacer>
                                <v-btn class="mr-4" outlined color="primary" @click.native="saveSettings">Salva</v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
			</v-row>

			<edocument-import-options></edocument-import-options>
		</v-tab-item>

	</v-tabs>
</template>

<script>
    
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'
	import EdocumentImportOptions from '@/components/modules/invoices/settings/EdocumentImportOptions'

    export default {
        name: 'e-invoices-settings',
		mixins: [SettingsOptionsMixin],
		components: {
			EdocumentImportOptions,
		},
        data() {
            return {
                model: 'e_invoice',
				stepIndex: 1,
				registering: false,
				deleting: false,
				settings_einvoice: {
                    'einvoice_provider': 'nothing',
                    'einvoice_sandbox': false,
                },
                settings: {
                    'attach_courtesy_invoice': false,
                },
                webhooks: {},
                currentConfiguration: {},
                e1: false,
            }
        },

        methods: {
			validateStepForm() {
				this.$validator.validateAll().then(result => {
					if (!result) {
						return false
					}

					this.stepIndex++

				}).catch(() => {

				})	
			},

            saveConfigurations() {
                this.$validator.validateAll().then(result => {
                    this.registering = true
                    if (!result) {
                        return false
                    } else {
                        this.axios.post('e-invoices-settings', this.settings_einvoice).then(response => {

                            this.$store.commit('setSnackbar', {
                                timeout: 6000,
                                text: response.data.message,
                                value: true, 
                                color: response.status == 201 ? 'success' : 'error'
                            })
                            if(response.status == 201) {
                                this.getConfigurations()
                            }
                            this.registering = false
                        }).catch(error => {
                            this.registering = false
                        })
                    }
                }).catch(() => {

                })
            },
            
            updateConfigurations() {
                this.$validator.validateAll().then(result => {
                    this.registering = true
                    if (!result) {
                        return false
                    } else {
                        this.axios.put('e-invoices-settings', this.settings_einvoice).then(response => {

                            this.$store.commit('setSnackbar', {
                                timeout: 6000,
                                text: response.data.message,
                                value: true, 
                                color: response.status == 200 ? 'success' : 'error'
                            })
                            this.registering = false
                        }).catch(error => {
                            this.registering = false
                        })
                    }
                }).catch(() => {

                })
            },
            
            getConfigurations() {
                this.axios.get('e-invoices-settings').then(response => {
                    this.currentConfiguration = response.data.data.einvoice_provider_config
                    this.$set(this.settings_einvoice, 'einvoice_provider', response.data.data.einvoice_provider)

                    switch(this.settings_einvoice['einvoice_provider']) {
                        case 'open_api':
                            // this.$set(this.settings_einvoice, 'apply_legal_storage', response.data.data.einvoice_provider_config.apply_legal_storage)
                            // this.$set(this.settings_einvoice, 'apply_signature', response.data.data.einvoice_provider_config.apply_signature)
                            this.$set(this.settings_einvoice, 'attach_courtesy_invoice', response.data.data.einvoice_provider_config.attach_courtesy_invoice)
                            this.$set(this.settings_einvoice, 'business_name', response.data.data.einvoice_provider_config.name)
                            this.$set(this.settings_einvoice, 'business_email', response.data.data.einvoice_provider_config.email)
                            this.$set(this.settings_einvoice, 'vat_number', response.data.data.einvoice_provider_config.fiscal_id)
                            this.$set(this.settings_einvoice, 'active', response.data.data.einvoice_provider_config.active)
                            this.$set(this.settings_einvoice, 'id', response.data.data.einvoice_provider_config.id)
                            this.$set(this.settings_einvoice, 'einvoice_sandbox', response.data.data.einvoice_sandbox)
                            break
                            
                        case 'aruba':
                            this.$set(this.settings_einvoice, 'attach_courtesy_invoice', response.data.data.einvoice_provider_config.attach_courtesy_invoice)
                            this.$set(this.settings_einvoice, 'business_name', response.data.data.einvoice_provider_config.name)
                            this.$set(this.settings_einvoice, 'business_email', response.data.data.einvoice_provider_config.email)
                            this.$set(this.settings_einvoice, 'vat_number', response.data.data.einvoice_provider_config.fiscal_id)
                            this.$set(this.settings_einvoice, 'username', response.data.data.einvoice_provider_config.username)
                            this.$set(this.settings_einvoice, 'password', response.data.data.einvoice_provider_config.password)
                            this.$set(this.settings_einvoice, 'einvoice_sandbox', response.data.data.einvoice_sandbox)
                            this.$set(this.settings_einvoice, 'id', true)

                            break
                    }
                }).catch(error => {
                    // error callback
                })
            },
            
            deleteConfigurations() {
                this.deleting = true
                this.axios.delete('e-invoices-settings').then(response => {

                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: response.data.message,
                        value: true, 
                        color: response.status == 200 ? 'success' : 'error'
                    })

                    if(response.status == 200) {
                        this.$set(this, 'settings_einvoice', {
                            'einvoice_provider': 'nothing',
                        })
                        this.stepIndex = 1
                    }
                    this.deleting = false
                }).catch(error => {
                    this.deleting = false
                })
            },
        },

        mounted() {
            this.getConfigurations()
            this.$store.commit('endProgress')
        }
    }
</script>